/** orderTime 비교용 숫자. Date·ms epoch 문자열 모두 Number()로 환산한다. 부재(undefined/'')·비정상 값은 -Infinity로 두어 맨 뒤로 보낸다. */
const orderTimeValue = (orderTime: Date | string | undefined): number => {
  if (!orderTime) return -Infinity; // undefined / '' (Number('')===0 이므로 명시 처리)
  const value = Number(orderTime); // Date → epoch ms, 문자열 → 숫자
  return Number.isFinite(value) ? value : -Infinity;
};

/**
 * orderTime 내림차순(최신 먼저)으로 정렬한 새 배열을 반환한다. 원본은 변형하지 않는다.
 * `orderTime`은 PswapOrder(BDL) 모델 필드(PrexTimestamp = Date)이지만, 이 모듈은
 * bunja/codegen 모델 import 체인 없이 cast로만 읽어 단위 테스트에서 안전하게 import된다.
 * (TP/SL 리스트 정렬용 — iOS/Android·legacy 경로와 동일 규칙)
 */
export const sortByOrderTimeDesc = <T>(orders: T[]): T[] =>
  [...orders].sort((a, b) => {
    // 뺄셈(-Infinity - -Infinity = NaN)은 동률 시 순서를 깨뜨리므로 -1/0/1로 비교한다.
    const av = orderTimeValue((a as { orderTime?: Date | string }).orderTime);
    const bv = orderTimeValue((b as { orderTime?: Date | string }).orderTime);
    if (av === bv) return 0;
    return av > bv ? -1 : 1;
  });
